import axios from 'axios';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import ParentfamilyForm from './ParentfamilyForm';
import Listprint from '../../Listprint';
const column = (label, field, width) => ({ label, field, sort: 'asc', width });
const columns = [column('Parent', 'name', 220)];
columns.push(column('Genre', 'genre', 90), column('Téléphone', 'tel', 130));
columns.push(column('E-mail', 'email', 180), column('Profession', 'profession', 140));
columns.push(column('Adresse', 'adress', 180), column('Élèves liés', 'students', 90));
columns.push({ label: 'Actions', field: 'action', sort: 'disabled', width: 90, printable: false });

class Parentfamily extends Component {
    state = { isModal: false, formData: null, parentfamilies: [], loading: true, loadError: false, deletingId: null };
    _isMounted = false;
    _requestId = 0;
    componentDidMount() { this._isMounted = true; this.getParentfamilies(); }
    componentWillUnmount() { this._isMounted = false; this._requestId += 1; }

    getParentfamilies = async () => {
        const requestId = ++this._requestId;
        this.setState({ loading: true, loadError: false });
        try {
            const response = await axios.get('parentfamilies');
            if (!this._isMounted || requestId !== this._requestId) return;
            const data = response.status === 200 && Array.isArray(response.data) ? response.data : [];
            this.setState({ parentfamilies: data, loading: false });
        } catch (error) {
            if (this._isMounted && requestId === this._requestId) this.setState({ loading: false, loadError: true });
        }
    };

    showModal = (parentfamily = null, refresh = false) => {
        this.setState((state) => ({ isModal: !state.isModal, formData: state.isModal ? null : parentfamily }), () => {
            if (refresh) this.getParentfamilies();
        });
    };

    handleCheck = (permission) => {
        try {
            const permissions = JSON.parse(localStorage.getItem('permissions') || '[]');
            return Array.isArray(permissions) && permissions.some((item) => permission === item.permission);
        } catch (error) { return false; }
    };

    delete = async (parentfamily) => {
        if (window.confirm('Confirmer la suppression de ce parent.') === false) return;
        this.setState({ deletingId: parentfamily.id });
        try {
            const response = await axios.delete('parentfamilies/' + parentfamily.id);
            toast(response.data.msg || 'Le parent a été supprimé.');
            await this.getParentfamilies();
        } catch (error) {
            toast((error.response && error.response.data.msg) || 'La suppression a échoué.');
        } finally { if (this._isMounted) this.setState({ deletingId: null }); }
    };

    getRows = () => this.state.parentfamilies?.sort((a, b) => a.user?.last_name.localeCompare(b.user?.last_name, "fr", { numeric: true }))
    .map((parentfamily) => {
        const user = parentfamily.user || {};
        const name = [user.last_name, user.family_name, user.first_name].filter(Boolean).join(' ');
        return {
            name: name || 'Nom non renseigné',
            genre: user.genre || '—',
            tel: user.tel || '—',
            email: user.email || '—',
            profession: user.profession || '—',
            adress: user.adress || '—',
            students: <span className='parentfamily-count'>{(user.users_ || []).length}</span>,
            action: <span className='parentfamily-actions'>
                {this.handleCheck('Modifier parent') && <button onClick={() => this.showModal(parentfamily)}><FeatherIcon icon='edit-3' size='15' /></button>}
                {this.handleCheck('Supprimer parent') && <button className='danger' onClick={() => this.delete(parentfamily)}><FeatherIcon icon='trash-2' size='15' /></button>}
            </span>
        };
    });

    render() {
        const { parentfamilies, loading, loadError } = this.state;
        const linked = parentfamilies.reduce((sum, item) => sum + ((item.user && item.user.users_) || []).length, 0);
        const phones = parentfamilies.filter((item) => item.user && item.user.tel).length;
        return <main className='parentfamilies-page'>
            <Helmet><title>{process.env.REACT_APP_NAME} | Parents et familles</title></Helmet>
            <header className='parentfamilies-hero'>
                <div><span>Communauté scolaire</span><h1>Parents et familles</h1><p>Centralisez les responsables familiaux, leurs coordonnées et les élèves rattachés.</p></div>
                <nav>
                    <Link to='/manuel#parentfamilies' className='btn guide'><FeatherIcon icon='book-open' size='18' /> Guide</Link>
                    {this.handleCheck('Ajouter parent') && <button className='btn add' onClick={() => this.showModal(null)}><FeatherIcon icon='user-plus' size='18' /> Nouveau parent</button>}
                </nav>
            </header>
            {!loading && !loadError && <section className='parentfamilies-stats'>
                <article><FeatherIcon icon='users' /><div><strong>{parentfamilies.length}</strong><span>Parents enregistrés</span></div></article>
                <article><FeatherIcon icon='user-check' /><div><strong>{linked}</strong><span>Liens avec des eleves</span></div></article>
                <article><FeatherIcon icon='phone' /><div><strong>{phones}</strong><span>Téléphones renseignés</span></div></article>
            </section>}
            {loading && <div className='parentfamilies-feedback'><FeatherIcon className="user-search-spin" icon="loader" /></div>}
            {!loading && loadError && <div className='parentfamilies-feedback error'><FeatherIcon icon='alert-circle' /><h2>Chargement impossible</h2><p>Vérifiez la connexion puis réessayez.</p><button className='btn btn-primary btn-sm' onClick={this.getParentfamilies}>Réessayer</button></div>}
            {!loading && !loadError && parentfamilies.length === 0 && <div className='parentfamilies-feedback'><FeatherIcon icon='users' /><h2>Aucun parent enregistré</h2><p>Ajoutez un premier responsable familial.</p></div>}
            {!loading && !loadError && parentfamilies.length > 0 && <section className='parentfamilies-list'>
                <header><div><span>Répertoire</span><h2>Coordonnées des responsables</h2></div><small>{parentfamilies.length} dossiers</small></header>
                <div><Listprint columns={columns} rows={this.getRows()} title='Liste des parents et familles' /></div>
            </section>}
            <ParentfamilyForm isModal={this.state.isModal} formData={this.state.formData} showModal={this.showModal} />
        </main>;
    }
}
export default Parentfamily;
